import { render, staticRenderFns } from "./RechargePage.vue?vue&type=template&id=2bd0dddd&scoped=true"
import script from "./RechargePage.vue?vue&type=script&lang=js"
export * from "./RechargePage.vue?vue&type=script&lang=js"
import style0 from "./RechargePage.vue?vue&type=style&index=0&id=2bd0dddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd0dddd",
  null
  
)

export default component.exports